export default __webpack_public_path__ + "static/media/12_harvestor_junek-min.c18c64f5.jpg";